import { useEffect } from "react";

/** Logs a click when a visitor arrives from one of our emails (?ec=<id>), then cleans the URL. */
const EmailClickTracker = () => {
  useEffect(() => {
    const url = new URL(window.location.href);
    const mid = url.searchParams.get("ec");
    if (!mid) return;
    url.searchParams.delete("ec");
    window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
    import("@/integrations/supabase/client").then(({ supabase }) =>
      supabase.functions.invoke("track-email-click", { body: { mid, path: url.pathname } }).catch(() => {}),
    );
  }, []);
  return null;
};

export default EmailClickTracker;
